/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { injectIntl, InjectedIntl } from 'react-intl';

import ProfileModel, { ProfileData } from '../../models/ProfileModel';
import { LocalizedListItem, Race } from '../../apiServices/ListsService';

interface Props {
  raceCollection: Race[];
  getInitialData(): void;
  profile: ProfileModel;
  primaryClass: string;
  secondaryClass: string;
  intl: any;
}

class LocalizedRace extends React.Component<Props, {}> {
  render() {
    const { profile, raceCollection, intl, primaryClass, secondaryClass } = this.props;

    // nothing selected yet
    if (!profile.hasValidRace()) {
      return <span/>;
    }

    // prefer not to answer
    if (profile.data.race_selection === 'no_answer') {
      return <span>{intl.formatMessage({ id: 'race.declineToAnswer.text' })}</span>;
    }

    const raceIdentityPresent = profile.data.race && profile.data.race.identity;

    return (
      <div>
        {
          raceIdentityPresent &&
          <div>
            <LocalizedProfileRaceIdentity profile={profile} className={primaryClass} />
          </div>
        }

        {
          raceIdentityPresent ?
            <LocalizedProfileRace
              profile={profile}
              raceCollection={raceCollection}
              className={secondaryClass}
              style={{ display: 'block' }}
              intl={intl}
            />
          :
            <LocalizedProfileRace
              profile={profile}
              raceCollection={raceCollection}
              className={primaryClass}
              intl={intl}
            />
        }
      </div>
    );
  }

  UNSAFE_componentWillMount() {
    if (this.props.getInitialData) {
      this.props.getInitialData();
    }
  }
}

interface LocalizedProfileRaceProps {
  profile: ProfileModel;
  raceCollection: Race[];
  className?: string;
  style?: object;
  intl: any;
}

export class LocalizedProfileRace extends React.Component<LocalizedProfileRaceProps, {}> {
  render() {
    const { profile, raceCollection, intl, className, style } = this.props;
    const raceNames = getLocalizedSelectedRaces(profile.data, raceCollection, intl).sort((a, b) => a.localeCompare(b));

    return (
      <div className={className} style={style}>
        {raceNames.join(' / ')}
      </div>
    );
  }
}

interface LocalizedRaceIdentityProps {
  profile: ProfileModel;
  className?: string;
  style?: object;
}

export class LocalizedProfileRaceIdentity extends React.Component<LocalizedRaceIdentityProps, {}> {
  render() {
    const { profile, className, style } = this.props;

    return (
      <div className={className} style={style}>
        {profile.data.race.identity}
      </div>
    );
  }
}

export function getLocalizedSelectedRaces(profileData: ProfileData, raceCollection: Race[], intl: InjectedIntl) {
  const raceId = profileData.race && profileData.race.race_id || [];

  const selectedRaces = raceCollection
    .filter(race => raceId.indexOf(race.id) >= 0);

  return LocalizedListItem.wrap(selectedRaces, intl)
    .map(race => race.name);
}

export default injectIntl(LocalizedRace);
